import {apiConstants, config, downloadBlob, requestOptions, requestTypes, sendRequest} from "../../../../Utilities/Api";

//************************************************** STANDARD API SERVER CALLS ****************************************

class serverAphLoanHistoryApi {

    static getAphLoanHistory(loanHistorySearchCriteria: Record<string, unknown>) {
        const queryParameters = new URLSearchParams(loanHistorySearchCriteria as Record<string, string>).toString();
        return sendRequest(
            requestOptions(`${config.URL}aph/loan/history?${queryParameters}`,
                requestTypes.GET,
            )
        );
    }

    static getDropdownListsForAphLoanSearch()
    {
        const isForLoanManagementValue = false;
        const queryParameters = new URLSearchParams({isForLoanManagementValue: String(isForLoanManagementValue)}).toString();
        return sendRequest(
            requestOptions(config.URL + `aph/loan/dropdown-lists?${queryParameters}`,
                requestTypes.GET,
            ),
        );
    }

    static getStudents(studentSearchCriteria: Record<string, unknown>) {
        const queryParameters = new URLSearchParams(studentSearchCriteria as Record<string, string>).toString();
        return sendRequest(
            requestOptions(`${config.URL}students/patrons?${queryParameters}`,
                requestTypes.GET,
            )
        );
    }

    static getAphLoanHistoryReport(aphLoanHistorySearchCriteria: Record<string, unknown>) {
        const params = {
            ...aphLoanHistorySearchCriteria,
        };
        const queryParameters = new URLSearchParams(params as Record<string, string>).toString();
        return downloadBlob(
            requestOptions(config.URL + `aph/reports/loan-history/export?${queryParameters}`,
                requestTypes.GET,
                null,
                apiConstants.successMessage.report.REPORT_DOWNLOADED,
            ),
        );
    }
}

export const aphLoanHistoryApi = config.environment.MODE === config.modes.SERVER ? serverAphLoanHistoryApi : serverAphLoanHistoryApi;
